import React from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import "./filterButtonStyle.scss";
const FilterButton = ({ id = "btn", label = "Filter", handleClick, testId }) => {
  return (
    <div className="overrideFilterButton">
      <button
        aria-describedby={id}
        variant="contained"
        type="button"
        name="btn"
        onClick={(e) => handleClick(e)}
        className="filterbtns"
        data-testid={testId || "filter-btn"}
      >
        <FilterListIcon id="icn" />
        {label}
      </button>
    </div>
  );
};

export default FilterButton;
